import { apiClient } from './client'
import type {
  AssistantConversationSummary,
  AssistantTurnSummary,
} from '@/features/assistant/types'

export const assistantApi = {
  async listConversations(params?: {
    limit?: number
    matter_id?: string
    workspace?: string
  }): Promise<AssistantConversationSummary[]> {
    const response = await apiClient.get<AssistantConversationSummary[]>('/assistant/conversations', {
      params,
    })
    return response.data
  },

  async getConversationHistory(
    conversationId: string,
    params?: { matter_id?: string; workspace?: string }
  ): Promise<AssistantTurnSummary[]> {
    const response = await apiClient.get<AssistantTurnSummary[]>(
      `/assistant/conversations/${conversationId}`,
      { params }
    )
    return response.data
  },
}
